import { useState } from 'react'
import { withRouter } from '../utils'
import axios from 'axios'

function DailyReportsGate({ navigate }) {
  const apiHost = process.env.REACT_APP_APIHOST || 'http://localhost:3033'
  const token = localStorage.getItem('token')

  // If logged in, load real DailyReports
  if (token) {
    const DailyReports = require('./DailyReports').default
    return <DailyReports navigate={navigate} />
  }

  // Not logged in — show restricted page with access request form
  return <RestrictedPage apiHost={apiHost} navigate={navigate} />
}

function RestrictedPage({ apiHost, navigate }) {
  const [form, setForm] = useState({ firstName:'', lastName:'', email:'', company:'', title:'', phone:'', message:'' })
  const [sent, setSent] = useState(false)
  const [sending, setSending] = useState(false)
  const [toast, setToast] = useState(null)

  const submit = async (e) => {
    e.preventDefault()
    if (!form.firstName || !form.lastName || !form.email || !form.company) {
      setToast({ msg: 'Please fill required fields.', type: 'warn' }); setTimeout(() => setToast(null), 3000); return
    }
    setSending(true)
    try {
      await axios.post(apiHost + '/contact/access-request', form)
      setSent(true)
    } catch(err) {
      setToast({ msg: 'Failed to send. Try again.', type: 'err' }); setTimeout(() => setToast(null), 3000)
    }
    setSending(false)
  }

  const inp = { width:'100%',background:'rgba(255,255,255,0.06)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:3,padding:'11px 14px',color:'#e6e6e6',fontSize:13,outline:'none',boxSizing:'border-box' }
  const lbl = { fontSize:10,color:'#888',textTransform:'uppercase',letterSpacing:1,marginBottom:4,display:'block' }
  const row = { display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:12 }

  return (
    <div style={{ background:'#141414',color:'#e6e6e6',minHeight:'100vh',fontFamily:'Inter,sans-serif' }}>
      {/* Header */}
      <div style={{ padding:'16px 24px',borderBottom:'1px solid rgba(255,255,255,0.06)',display:'flex',justifyContent:'space-between',alignItems:'center' }}>
        <a href="/"><img src="/icons/logo.webp" alt="FORTE" style={{ height:16,opacity:0.85 }} /></a>
        <a href="/login" style={{ fontSize:11,color:'#C29717',textDecoration:'none',border:'1px solid rgba(194,151,23,0.3)',borderRadius:3,padding:'6px 16px' }}>Sign in</a>
      </div>

      {/* Hero with screenshot */}
      <div style={{ position:'relative',overflow:'hidden' }}>
        <div style={{ position:'relative',maxWidth:1100,margin:'0 auto',padding:'60px 24px 40px',display:'flex',gap:48,alignItems:'center',flexWrap:'wrap' }}>
          <div style={{ flex:'1 1 400px',minWidth:300 }}>
            <div style={{ fontSize:9,color:'#C29717',textTransform:'uppercase',letterSpacing:2,marginBottom:8 }}>Restricted access</div>
            <h1 style={{ fontSize:28,fontWeight:600,lineHeight:1.3,margin:'0 0 16px' }}>Intelligence & Risk Monitoring</h1>
            <p style={{ fontSize:14,color:'#888',lineHeight:1.7,margin:'0 0 24px' }}>
              Access real-time conflict intelligence, daily reports, satellite assessments, and threat analytics across critical geographies. Fill in the form below to request access.
            </p>
            <div style={{ display:'flex',flexWrap:'wrap',gap:8 }}>
              {['Daily Reports','Interactive Map','Satellite Analysis','Threat Analytics','SMS Alerts','Evacuation Planning'].map(f => (
                <span key={f} style={{ fontSize:10,padding:'4px 10px',border:'1px solid rgba(194,151,23,0.2)',borderRadius:2,color:'#C29717',background:'rgba(194,151,23,0.05)' }}>{f}</span>
              ))}
            </div>
          </div>
          <div style={{ flex:'1 1 400px',minWidth:300 }}>
            <img src="/icons/mockup.webp" alt="Platform" style={{ width:'100%',borderRadius:6,border:'1px solid rgba(255,255,255,0.06)',boxShadow:'0 12px 40px rgba(0,0,0,0.4)' }} />
          </div>
        </div>
      </div>

      {/* Form */}
      <div style={{ maxWidth:560,margin:'0 auto',padding:'20px 24px 60px' }}>
        {sent ? (
          <div style={{ background:'#1a1a1a',border:'1px solid rgba(76,175,80,0.2)',borderRadius:4,padding:'32px',textAlign:'center' }}>
            <div style={{ fontSize:24,marginBottom:12 }}>&#9989;</div>
            <div style={{ fontSize:16,fontWeight:500,marginBottom:8 }}>Request sent</div>
            <div style={{ fontSize:13,color:'#888' }}>Our team will review your request and get back to you shortly.</div>
          </div>
        ) : (
          <form onSubmit={submit}>
            <div style={{ fontSize:12,fontWeight:600,color:'#ccc',marginBottom:16 }}>Request access</div>
            <div style={row}>
              <div><label style={lbl}>First name *</label><input style={inp} value={form.firstName} onChange={e => setForm({...form,firstName:e.target.value})} required /></div>
              <div><label style={lbl}>Last name *</label><input style={inp} value={form.lastName} onChange={e => setForm({...form,lastName:e.target.value})} required /></div>
            </div>
            <div style={row}>
              <div><label style={lbl}>Email *</label><input style={inp} type="email" value={form.email} onChange={e => setForm({...form,email:e.target.value})} required /></div>
              <div><label style={lbl}>Company *</label><input style={inp} value={form.company} onChange={e => setForm({...form,company:e.target.value})} required /></div>
            </div>
            <div style={row}>
              <div><label style={lbl}>Title</label><input style={inp} value={form.title} onChange={e => setForm({...form,title:e.target.value})} /></div>
              <div><label style={lbl}>Phone</label><input style={inp} value={form.phone} onChange={e => setForm({...form,phone:e.target.value})} /></div>
            </div>
            <div style={{ marginBottom:16 }}>
              <label style={lbl}>Message</label>
              <textarea style={{...inp,minHeight:80,resize:'vertical'}} value={form.message} onChange={e => setForm({...form,message:e.target.value})} placeholder="Tell us about your needs..." />
            </div>
            <button type="submit" disabled={sending} style={{ background:'#C29717',color:'#fff',border:'none',borderRadius:3,padding:'12px 32px',fontSize:13,fontWeight:600,cursor:'pointer',width:'100%',letterSpacing:0.5 }}>
              {sending ? 'Sending...' : 'Request access'}
            </button>
          </form>
        )}
      </div>

      {/* Footer */}
      <div style={{ padding:'20px 24px',borderTop:'1px solid rgba(255,255,255,0.04)',textAlign:'center' }}>
        <span style={{ fontSize:8,color:'rgba(255,255,255,0.15)',textTransform:'uppercase',letterSpacing:2 }}>FORTE Intel &middot; Navigating risk with strategic foresight</span>
      </div>

      {toast && (
        <div style={{ position:'fixed',bottom:24,left:'50%',transform:'translateX(-50%)',background:'#1a1a1a',border:'1px solid '+(toast.type==='err'?'rgba(229,85,85,0.3)':'rgba(194,151,23,0.3)'),borderRadius:4,padding:'12px 24px',fontSize:13,color:toast.type==='err'?'#e55':'#C29717',zIndex:99999,boxShadow:'0 8px 24px rgba(0,0,0,0.5)' }}>{toast.msg}</div>
      )}
    </div>
  )
}

export default withRouter(DailyReportsGate)
